import React from 'react';
import { Box, Typography, IconButton, Divider, Drawer, Avatar } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { AccountSelector } from '../../MainLayout/components/AccountSelector';
import useProductsProvider from '../../MainLayout/hooks/useProductsProvider';
import { Menu } from '../../../common-components';
import LogoutIcon from '@mui/icons-material/Logout';
import LogoutConfirmationModal from '../../MainLayout/components/LogoutConfirmationModal';
import { useSideBarHandler } from '../hooks/useSideBarHandler';
import { ROUTE_PATHS } from '../../../routes/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { SidebarNavItem } from './SidebarNavItem';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';

export function Sidebar() {
  const { isSidebarOpen, xsScreen, toggleSidebar, setInitiateLogout, handleLogout, initiateLogout, isLogoutInProgress, currentUser } = useSideBarHandler();
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarWidth = isSidebarOpen ? 280 : xsScreen ? 0 : 60;

  const { products, currentProduct, setCurrentProduct } = useProductsProvider();

  const isDashboard = location.pathname === ROUTE_PATHS.ADMIN_DASHBOARD;
  const isUsers = location.pathname.startsWith(ROUTE_PATHS.ADMIN_USERS);
  const isKnowledgeBase = location.pathname.startsWith(ROUTE_PATHS.ADMIN_KNOWLEDGE_BASE);


  return (
    <Drawer open={true} anchor="left" variant={xsScreen && isSidebarOpen ? 'temporary' : 'permanent'} ModalProps={{ keepMounted: true }}>
      <Box
        sx={{
          width: `${sidebarWidth}px`,
          backgroundColor: 'background.default',
        }}
      >
        <Box
          sx={{
            height: '100vh',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isSidebarOpen ? 'unset' : 'center',
            position: 'relative',
          }}
        >
          {/* Header */}
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', px: 0.5, justifyContent: isSidebarOpen ? 'space-between' : 'center' }}>
            <AccountSelector accounts={products} selectedId={currentProduct} onChange={(id) => setCurrentProduct(id)} isSidebarOpen={isSidebarOpen} currentUser={currentUser} />

            <IconButton onClick={() => toggleSidebar()} sx={isSidebarOpen ? {} : { display: 'none' }}>
              <MenuOpenIcon sx={{ transform: isSidebarOpen ? 'rotate(0deg)' : 'rotate(180deg)', transition: 'transform 0.3s ease-in-out' }} />
            </IconButton>
          </Box>

          <Divider />

          <Box sx={{ py: 2 }}>
            <SidebarNavItem
              id="dashboard"
              selected={isDashboard}
              onClick={() => {
                navigate(ROUTE_PATHS.ADMIN_DASHBOARD);
                if (xsScreen) toggleSidebar(false);
              }}
              title="Dashboard"
              icon={<HomeRoundedIcon fontSize="small" />}
            />
            <SidebarNavItem
              id="users"
              selected={isUsers}
              onClick={() => {
                navigate(ROUTE_PATHS.ADMIN_USERS);
                if (xsScreen) toggleSidebar(false);
              }}
              title="Users"
              icon={<PeopleRoundedIcon fontSize="small" />}
            />
            <SidebarNavItem
              id="knowledge-base"
              selected={isKnowledgeBase}
              onClick={() => {
                navigate(ROUTE_PATHS.ADMIN_KNOWLEDGE_BASE);
                if (xsScreen) toggleSidebar(false);
              }}
              title="Knowledge Base"
              icon={<AutoStoriesRoundedIcon fontSize="small" />}
            />
          </Box>
          <Box sx={{ mt: 'auto' }}>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '0.5rem' }}>
              <Box>
                {isSidebarOpen && (
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
                    v1.0.0 (Beta)
                  </Typography>
                )}
              </Box>
              {!currentUser?.productId && (
                <Menu
                  trigger={<Avatar src={currentUser?.name} />}
                  items={[
                    {
                      icon: <HomeRoundedIcon fontSize="small" />,
                      label: 'Go to Sena',
                      onClick: () => {
                        navigate(ROUTE_PATHS.PORTAL);
                      },

                    },
                    {
                      icon: <LogoutIcon fontSize="small" />,
                      label: 'Logout',
                      onClick: () => setInitiateLogout(true),
                    },
                  ]}
                />
              )}
            </Box>
          </Box>
        </Box>
        <LogoutConfirmationModal open={initiateLogout} onClose={() => setInitiateLogout(false)} onLogout={handleLogout} loading={isLogoutInProgress} />
      </Box>
    </Drawer>
  );
}
